import { type Ref } from 'vue-demi'
import { type DirectLayoutModeConfig } from '../../../settings'

export function useActivationPreviewListGrid (
  currentLayout: Ref<DirectLayoutModeConfig>,
  type: 'overlay' | 'outerOverlay'
) {
  function getListStyle (area: string) {
    const styles = currentLayout.value?.targets?.[type]?.areas?.[area]?.style ?? {}
    return {
      overflow: 'hidden',
      ...styles
    }
  }
  function getOptions (area: string) {
    const isLeft = area.includes('left')
    const isRight = area.includes('right')
    const options = currentLayout.value?.targets?.[type]?.areas?.[area]?.options ?? {}
    return {
      portrait: false,
      align: isLeft ? 'left' : isRight ? 'right' : 'center',
      left: isLeft,
      ...options
    }
  }
  return {
    getListStyle,
    getOptions
  }
}
